import { render, staticRenderFns } from "./PropChannelInTimeChart.vue?vue&type=template&id=13b1f5fc&"
import script from "./PropChannelInTimeChart.vue?vue&type=script&lang=js&"
export * from "./PropChannelInTimeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports